import React from 'react';
import { StarIcon } from 'lucide-react';
const Testimonials = () => {
  return <section className="py-16 bg-gray-50" data-id="element-370">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-371">
        <div className="text-center mb-16" data-id="element-372">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-373">お客様の声</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-374">
            多くのお客様にご信頼いただいております。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-375">
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-376">
            <div className="flex text-yellow-400 mb-4" data-id="element-377">
              <StarIcon className="h-5 w-5 fill-current" data-id="element-378" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-379" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-380" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-381" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-382" />
            </div>
            <blockquote className="text-gray-700 mb-6" data-id="element-383">
              "ジャパンクリーニングセンターのおかげで、当ホテルの清潔さに対するお客様からの評価が大きく向上しました。スタッフの方々の仕事は丁寧で、常に信頼できます。"
            </blockquote>
            <div className="flex items-center" data-id="element-384">
              <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="お客様の写真" className="h-12 w-12 rounded-full mr-4" data-id="element-385" />
              <div data-id="element-386">
                <p className="font-medium text-gray-900" data-id="element-387">John Smith</p>
                <p className="text-gray-600 text-sm" data-id="element-388">都内高級ホテル 支配人</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-389">
            <div className="flex text-yellow-400 mb-4" data-id="element-390">
              <StarIcon className="h-5 w-5 fill-current" data-id="element-391" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-392" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-393" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-394" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-395" />
            </div>
            <blockquote className="text-gray-700 mb-6" data-id="element-396">
              "複数の民泊物件を運営していますが、ジャパンクリーニングセンターのサービスのおかげで管理が非常に楽になりました。写真付きの報告で安心でき、お客様からの清潔さに関する評価も高評価です。"
            </blockquote>
            <div className="flex items-center" data-id="element-397">
              <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="お客様の写真" className="h-12 w-12 rounded-full mr-4" data-id="element-398" />
              <div data-id="element-399">
                <p className="font-medium text-gray-900" data-id="element-400">鈴木 美咲</p>
                <p className="text-gray-600 text-sm" data-id="element-401">民泊オーナー（京都）</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-402">
            <div className="flex text-yellow-400 mb-4" data-id="element-403">
              <StarIcon className="h-5 w-5 fill-current" data-id="element-404" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-405" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-406" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-407" />
              <StarIcon className="h-5 w-5 fill-current" data-id="element-408" />
            </div>
            <blockquote className="text-gray-700 mb-6" data-id="element-409">
              "オフィス環境が驚くほど改善しました。スタッフの方々は効率的で、職場環境を尊重しながら徹底的な清掃を行ってくれます。ビジネス向けに非常におすすめです。"
            </blockquote>
            <div className="flex items-center" data-id="element-410">
              <img src="https://randomuser.me/api/portraits/men/67.jpg" alt="お客様の写真" className="h-12 w-12 rounded-full mr-4" data-id="element-411" />
              <div data-id="element-412">
                <p className="font-medium text-gray-900" data-id="element-413">中村 健二</p>
                <p className="text-gray-600 text-sm" data-id="element-414">IT企業 総務部長</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-415">
          <p className="text-gray-600" data-id="element-416">
            Join our growing list of satisfied clients
          </p>
        </div>
      </div>
    </section>;
};
export default Testimonials;